export class ContractorBaseAuction {

  constructor() { }

  contractName: string;
}



// WEBPACK FOOTER //
// ./src/app/modules/home/models/contractor-base-auction.ts